import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import ShopProductCard from './ProductCard';

// ----------------------------------------------------------------------

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function ProductList({ products = [], ...other }) {
  // The parent should control sizing (e.g. place this component inside
  // a <Grid item xs=12 md=6> to make it half-width). Here we render a
  // Grid container with spacing and product items that form two columns
  // inside that area.
  return (
    <Grid container spacing={3} {...other}>
      {products.map((product, index) => (
        // Use two columns layout within the parent width
        <Grid key={product.id || index} item xs={12} sm={6} md={6}>
          <ShopProductCard product={product} />
        </Grid>
      ))}
    </Grid>
  );
}